// `_wakeLock` is used as a flag also to indicate that the user has turned _wakeLock on (then `_wakeLock` is created).
// If it's turned off() then `_wakeLock` is set to null.
// The component will try to keep _wakeLock on and re-request it in case it gets released due to visibility change.

let _wakeLock: any;

// The wakelock can be released when visibility changes to hidden (on mobile devices for example) and after the user switches back to our app then we should re-acquire it
document.addEventListener("visibilitychange", () => {
    // window got focus, then check if wakeLock is on and has been released when it got hidden
    if (document.visibilityState === "visible" && _wakeLock && _wakeLock.released) {
        wakeLockOn(); // try to keep wakeLock on
    }
});
    
export async function wakeLockOn() {
    
    const nav = navigator as any;

    if (!nav.wakeLock) return console.log("Screen Wake Lock API is not supported on this platform.");
    try {
        if (_wakeLock && !_wakeLock.released) {
            // leave release of old wakeLock in the background
            try { await _wakeLock.release(); }
            catch (exc) { console.log(`Can't release old wakeLock:`, exc); }
        }
        _wakeLock = await nav.wakeLock.request("screen");
        _wakeLock.addEventListener("release", (event: any) => console.log(`WakeLock has been released:`, event));
    } catch (exc) {
        console.error(`Can't request screen wakeLock:`, exc);
    }
}
    
export async function wakeLockOff() {
    if (!_wakeLock) return;
    await _wakeLock.release();
    _wakeLock = null;
}
